import { useState } from 'react';

// Типы для параметров функции useSmartQuery
interface UseSmartQueryParams<QueryArg, ResultType> {
  queryHook: any; // Хук запроса
  params: QueryArg; // Параметры запроса
  isSkip?: boolean;
  initialData: ResultType; // Начальные данные
  noSSRdata?: boolean;
}

// Типизированная функция useSmartQuery
export function useSmartQuery<QueryArg, ResultType>({
  queryHook,
  params,
  isSkip,
  initialData,
}: UseSmartQueryParams<QueryArg, ResultType>): {
  data: typeof initialData;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  isFetching: boolean;
  isSuccess: boolean;
} {
  // Формируем ключ запроса (null, если params нет)
  const queryKey = JSON.stringify(params ?? null);

  // Сохраняем ключ первого рендера
  const [firstRenderKey] = useState(queryKey);

  // Если ключ совпадает, пропускаем запрос
  const shouldSkip = queryKey === firstRenderKey;

  // Вызываем переданный хук запроса
  const queryResult = queryHook(params, { skip: (initialData && shouldSkip) || isSkip });

  return {
    data: initialData && shouldSkip ? initialData : queryResult.data,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error,
    isFetching: queryResult.isFetching,
    isSuccess: queryResult.isSuccess,
  };
}
